import React from 'react';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './empty-state.style';

export enum IconSizes {
  Default = 'default',
  Large = 'large',
}

export type EmptyStateProps = {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: string;
  iconSize?: IconSizes;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  iconSize = IconSizes.Default,
}) => (
  <Styled.Container>
    <Styled.IconContainer $large={iconSize === IconSizes.Large}>
      <Icon icon={icon} />
    </Styled.IconContainer>
    <Styled.Title>{title}</Styled.Title>
  </Styled.Container>
);
